import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import {getClassification,payloadToObject,severityBadgeClass} from "./NotificationMonitoring";

function NotificationDetailsDrawer({ item, guide, onlyPayload = false }) {
    const [payloadView, setPayloadView] = useState("json");
    const [expandedSections, setExpandedSections] = useState({});

    useEffect(() => {
        setExpandedSections({});
        setPayloadView("json");
    }, [item]);

    if (!item) {
        return null;
    }

    const classification = getClassification(
        item.type,
        guide
    );

    const payloadObj = payloadToObject(item.payload);

    const topLevelSections = {
        ANY_OFFER_CHANGED: [
            /^Offers\s+\d+$/i,
            /^Summary$/i,
            /^Offer Change Trigger$/i
        ],

        B2B_ANY_OFFER_CHANGED: [
            /^Offers\s+\d+$/i,
            /^Summary$/i,
            /^Offer Change Trigger$/i
        ],

        FBA_INVENTORY_AVAILABILITY_CHANGES: [
            /^Fulfillment Inventory By Marketplace\s+\d+$/i
        ],

        ORDER_CHANGE: [
            /^Summary$/i,
            /^Order Change Trigger$/i
        ],

        PRICING_HEALTH: [
            /^Summary$/i,
            /^Merchant Offer$/i,
            /^Offer Change Trigger$/i
        ],

        ACCOUNT_STATUS_CHANGED: [
            /^Account Status Change Notification$/i
        ]
    };

    const isTopLevelSection = (label) => {
        const patterns =
            topLevelSections[item.type] || [];

        return patterns.some((pattern) =>
            pattern.test(String(label))
        );
    };

    const toggleSection = (key) => {
        setExpandedSections((prev) => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const isExpanded = (key) => {
        return expandedSections[key] === true;
    };

    const Arrow = ({ open }) => (
        <span
            className={`anm-payload-arrow ${open
                    ? "anm-arrow-open"
                    : "anm-arrow-closed"
                }`}
        />
    );

    const SectionHeader = ({
        label,
        sectionKey
    }) => {

        const open =
            isExpanded(sectionKey);

        return (
            <div
                className="anm-payload-section-header"
                onClick={() =>
                    toggleSection(sectionKey)
                }
            >
                <span>
                    {label}
                </span>

                <Arrow open={open} />
            </div>
        );
    };

    const ChildHeader = ({ label }) => (
        <div className="anm-payload-child-header">
            {label}
        </div>
    );

    const ValueRow = ({ item }) => {

        if (
            item.isHeader &&
            item.label
        ) {
            return (
                <ChildHeader
                    label={item.label}
                />
            );
        }

        if (
            !item.label ||
            item.label === ":"
        ) {
            return (
                <Row className="anm-payload-value-row m-0">
                    <Col md={12} className="anm-payload-field-value p-0">
                        {item.value != null &&
                            item.value !== ""
                            ? String(item.value)
                            : "-"}
                    </Col>
                </Row>
            );
        }

        return (
            <Row className="anm-payload-value-row m-0 align-items-center">
                <Col md={4} className="anm-payload-field-label p-0">
                    {item.label} :
                </Col>
                <Col md={8} className="anm-payload-field-value p-0">
                    {item.value != null &&
                        item.value !== ""
                        ? String(item.value)
                        : "-"}
                </Col>
            </Row>
        );
    };

    const createSections = () => {

        const sections = [];
        let currentSection = null;

        (Array.isArray(item.payload)
            ? item.payload
            : []
        ).forEach((payloadItem) => {

            if (
                payloadItem.isHeader &&
                isTopLevelSection(
                    payloadItem.label
                )
            ) {

                currentSection = {
                    label: payloadItem.label,
                    items: []
                };

                sections.push(
                    currentSection
                );

            } else if (currentSection) {

                currentSection.items.push(
                    payloadItem
                );

            } else {

                sections.push({
                    label: null,
                    items: [payloadItem]
                });

                currentSection =
                    sections[
                    sections.length - 1
                    ];
            }
        });

        return sections;
    };

    const renderSection = (
        section,
        index
    ) => {

        if (!section.label) {

            return section.items.map(
                (payloadItem, itemIndex) => (
                    <ValueRow
                        key={itemIndex}
                        item={payloadItem}
                    />
                )
            );
        }

        const sectionKey =
            `section-${index}`;

        const open =
            isExpanded(sectionKey);

        return (
            <div
                key={sectionKey}
                className="anm-payload-section"
            >

                <SectionHeader
                    label={section.label}
                    sectionKey={sectionKey}
                />

                {open && (
                    <div className="anm-payload-section-content">

                        {section.items.map(
                            (payloadItem, itemIndex) => (
                                <ValueRow
                                    key={itemIndex}
                                    item={payloadItem}
                                />
                            )
                        )}

                    </div>
                )}

            </div>
        );
    };

    const sections = createSections();

    return (
        <div className="anm-details">

            {!onlyPayload && (
                <>


                    <Row className="mb-3">

                        <Col md={6}>

                            <div className="anm-info-box">

                                <div className="anm-detail-label">
                                    Notification Type
                                </div>

                                <div className="anm-details-title">
                                    {item.type || "-"}
                                </div>

                            </div>

                        </Col>

                        <Col md={6}>

                            <div className="anm-info-box">

                                <div className="anm-detail-label">
                                    Store
                                </div>

                                <div className="anm-store-name">
                                    {item.store || "-"}
                                </div>

                            </div>

                        </Col>

                    </Row>

                    <Row className="anm-identifier-row mb-3">

                        <Col md={4}>

                            <div className="anm-info-box">

                                <div className="anm-detail-label">
                                    Seller ID
                                </div>

                                <div className="anm-info-value anm-monospace">
                                    {item.sellerId || "N/A"}
                                </div>

                            </div>

                        </Col>


                        <Col md={4}>

                            <div className="anm-info-box">

                                <div className="anm-detail-label">
                                    ASIN
                                </div>

                                <div className="anm-info-value">
                                    {item.asin || "N/A"}
                                </div>

                            </div>

                        </Col>


                        <Col md={4}>

                            <div className="anm-info-box">

                                <div className="anm-detail-label">
                                    SKU
                                </div>

                                <div className="anm-info-value">
                                    {item.sku || "N/A"}
                                </div>

                            </div>

                        </Col>

                    </Row>

                    <Row className="mb-3">

                        <Col md={6}>

                            <div className="anm-detail-section mb-0">

                                <div className="anm-detail-label">
                                    Classification
                                </div>

                                <div className="anm-classification">

                                    <Row className="w-100 align-items-center m-0">

                                        <Col md={4} className="anm-classification-item px-1">

                                            <span className="anm-classification-label">
                                                Severity
                                            </span>

                                            <span
                                                className={`anm-badge ${severityBadgeClass(
                                                    classification.severity
                                                )}`}
                                            >
                                                {classification.severity}
                                            </span>

                                        </Col>


                                        <Col md={4} className="anm-classification-item px-1">

                                            <span className="anm-classification-label">
                                                Impact
                                            </span>

                                            <strong>
                                                {classification.businessImpact}
                                            </strong>

                                        </Col>


                                        <Col md={4} className="anm-classification-item px-1">

                                            <span className="anm-classification-label">
                                                Attention
                                            </span>

                                            <span
                                                className={`anm-badge ${classification.needsAttention ===
                                                        "Yes"
                                                        ? "anm-badge-attention-yes"
                                                        : "anm-badge-attention-no"
                                                    }`}
                                            >
                                                {classification.needsAttention}
                                            </span>

                                        </Col>

                                    </Row>

                                </div>

                            </div>

                        </Col>


                        <Col md={6}>

                            <div className="anm-detail-section mb-0">

                                <div className="anm-detail-label">
                                    Recommended Action
                                </div>

                                <div className="anm-recommended-action-box">
                                    {classification.recommendedAction}
                                </div>

                            </div>

                        </Col>

                    </Row>
                </>
            )}

            <div className="anm-detail-section anm-payload-section-wrapper mb-0">

                <Row className="anm-payload-header align-items-center mb-2">

                    <Col md={6}>

                        <div className="anm-detail-label mb-0">
                            {onlyPayload ? "Payload Data" : "Notification Payload"}
                        </div>

                    </Col>


                    <Col md={6} className="d-flex justify-content-end">

                        <div className="anm-view-toggle">

                            <button
                                type="button"
                                className={
                                    payloadView === "json"
                                        ? "active"
                                        : ""
                                }
                                onClick={() =>
                                    setPayloadView("json")
                                }
                            >
                                JSON
                            </button>


                            <button
                                type="button"
                                className={
                                    payloadView === "data"
                                        ? "active"
                                        : ""
                                }
                                onClick={() =>
                                    setPayloadView("data")
                                }
                            >
                                Data View
                            </button>

                        </div>

                    </Col>

                </Row>


                {payloadView === "json" && (

                    <pre className="anm-payload-pre">
                        {JSON.stringify(
                            payloadObj,
                            null,
                            2
                        )}
                    </pre>

                )}


                {payloadView === "data" && (

                    <div className="anm-payload-cascade">

                        {sections.length === 0 ? (

                            <div className="anm-no-payload">
                                No payload fields
                            </div>

                        ) : (

                            sections.map(
                                (section, index) =>
                                    renderSection(
                                        section,
                                        index
                                    )
                            )

                        )}

                    </div>

                )}

            </div>

        </div>
    );
}

export default NotificationDetailsDrawer;